import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/upkeeptask/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/upkeeptask/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/upkeeptask/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/upkeeptask/submit', params,options)

export const update = (params, options) =>
request.post('/api/upkeeptask/update', params,options)

export const getReport = (params, options) =>
  request.get('/api/upkeeptask/getReport', Object.assign({}, options, { params }))
